import differenceInDays from 'date-fns/difference_in_days';

export default function isBookingDateValid(departureDate) {
  return differenceInDays(departureDate, new Date()) >= 4;
}